import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet";
import CartMainContent from "../components/CartMainContent";
import CartNoCardsFound from "../components/CartNoCardsFound";
import "../styles/cart.scss";
import "../styles/cart-checkout.scss";
import loadable from "@loadable/component";
const CardCashSpinner = loadable(() =>
  import(
    /* webpackChunkName: "CardCashSpinner" */ "../components/CardCashSpinner"
  )
);
import { useDispatch, useSelector } from "react-redux";
import { initAppBrowser } from "@actions/initApp";

const CartMain = styled.div`
  padding-top: ${props => props.paddingTop};
  background-image: linear-gradient(
    to bottom,
    rgba(34, 176, 252, 0.04),
    rgba(34, 176, 252, 0)
  );
  margin-bottom: 100px;
  position: relative;

  @media (max-width: 1100px) {
    mix-blend-mode: normal;
  }
  @media (max-width: 900px) {
    margin-bottom: 0px;
  }
  @media (max-width: 700px) {
    padding-top: ${props => props.paddingMobileTop};
  }
  @media (max-height: 650px) {
    padding-top: ${props => props.paddingMobileTopShort};
  }
`;

const LoaderContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: white;
  background-image: linear-gradient(
    to bottom,
    rgba(34, 176, 252, 0.04),
    rgba(34, 176, 252, 0)
  );
  margin-top: -75px;

  @media (max-height: 650px) {
    margin-top: -25px;
  }
`;

const Loader = styled.div`
  margin-top: 68px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding-bottom: 127px;
  padding-top: 46px;
  position: relative;

  @media (max-width: 767px) {
    padding-bottom: 87px;
    padding-top: 15px;
  }
  @media (max-width: 450px) {
    padding-top: 0px;
  }
`;

const Cart = () => {
  const dispatch = useDispatch();
  const cardsBuy = useSelector(state => state.cardsBuy);
  const initialCartLoading = useSelector(
    state => state.popupsActions.initialCartLoading
  );
  const bannersList = useSelector(state => state.banners.bannersList);

  useEffect(() => {
    dispatch(initAppBrowser(["messages", "buy", "new"]));
  }, []);
  const newCardArray = Object.values(cardsBuy);

  return (
    <CartMain
      className="cart-main-container"
      paddingTop={bannersList.length > 0 ? "80px" : "205px"}
      paddingMobileTop={bannersList.length > 0 ? "50px" : "170px"}
      paddingMobileTopShort={bannersList.length > 0 ? "50px" : "120px"}
    >
      <Helmet title={`Shopping Cart | CardCash`} />
      <div>
        <>
          {newCardArray.length > 0 && <CartMainContent />}
          {newCardArray.length < 1 && (
            <EmptyState>
              {!initialCartLoading ? (
                <div className="main-container-page-width">
                  <CartNoCardsFound />
                </div>
              ) : (
                <LoaderContainer>
                  <Loader>
                    <CardCashSpinner />
                  </Loader>
                </LoaderContainer>
              )}
            </EmptyState>
          )}
        </>
      </div>
    </CartMain>
  );
};

export default Cart;
